import React, { useRef, useEffect } from 'react';

const LoadingSpinner = ({ isVisible, loadingText = "Chargement en cours..." }) => {
    const spinAnim = useRef(0);
    const animationRef = useRef(null);
    const spinnerRef = useRef(null);

    useEffect(() => {
        if (isVisible) {
            const animate = () => {
                spinAnim.current += 2; // Pas de modulo, on laisse la valeur augmenter
                if (spinnerRef.current) {
                    spinnerRef.current.style.transform = `rotate(${spinAnim.current}deg)`;
                }
                animationRef.current = requestAnimationFrame(animate);
            };
            animate();
        } else {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        }

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 9999,
            backdropFilter: 'blur(5px)'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{
                    position: 'relative',
                    width: '80px',
                    height: '80px',
                    marginBottom: '20px'
                }}>
                    <div ref={spinnerRef} style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        border: '5px solid #153146',
                        borderTop: '5px solid #f1f3f5',
                        borderRight: '5px solid #153146'
                        // Transition supprimée pour éviter les allers-retours
                    }}></div>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(235, 235, 235, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img
                            src="/assets/images/logo/logo.png"
                            alt="Logo"
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%'
                            }}
                        />
                    </div>
                </div>
                {loadingText && (
                    <p style={{
                        color: '#333',
                        fontSize: '16px',
                        fontWeight: 500
                    }}>{loadingText}</p>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner;